import styled from 'styled-components'
import { Tooltip } from 'react-tooltip'

import { mq, pxToRem, sizes } from '../../theme'
import Link from '../Link'

export const Container = styled(Tooltip)<{ $color?: string }>`
  --lexicontooltip-color__background: ${({ $color, theme }) =>
    $color ? $color : theme.colors.yellowPale};
  --lexicontooltip-color__text: ${({ $color, theme }) =>
    $color === theme.colors.black ? theme.colors.white : theme.colors.black};
  &.react-tooltip {
    ${({ theme }) => theme.textStyles.m375_bodySmall}
    padding: ${pxToRem(8)} ${pxToRem(12)};
    border-radius: 0;
    color: var(--lexicontooltip-color__text);
    background: var(--lexicontooltip-color__background);
    opacity: 1;
    z-index: ${({ theme }) => theme.zIndexes.modal};
  }
`
export const _Link = styled(Link)`
  color: inherit;
  &:hover,
  &:focus {
    text-decoration: underline;
  }
  &:focus-visible {
    outline: 0 none;
  }
  @media ${mq(sizes.tablet)} {
  }
`
